import type { SearchType } from 'src/types';
import { getWS_Code } from 'src/utils';
export type StatusType = 'planned' | 'active' | 'completed' | 'blocked';
export type WithArchived = boolean;
export type SearchPayloadType = {
    type: SearchType;
    keyword?: string;
    order_by?: string;
    status_type?: string;
    with_archived?: WithArchived;
    page: number;
    include?: string;
    assigned_to_me?: boolean;
};
export enum API_TEMPLATE {
    GET_USER_INFORMATION = '/me',
    GET_USER_CONFIG = '/me/config',
    SEARCH_API = `/search/1`,
    GET_PERMISSION = `/workspace/{ws_code}/permissions`,

    GET_ROOT_ROLES = `/workspace/{ws_code}/ws-user-roles/{id}`,
    GET_WS_PAGES = `/workspaces?page=1&per_page=1&include_ws={ws_code}`
}

export enum API_METHOD {
    GET = 'get',
    PUT = 'put',
    POST = 'post',
    DELETE = 'delete'
}

export type ApiConfig<T = any> = {
    url: string;
    method: API_METHOD;
    params?: T;
    data?: T;
};

type APIFunctionType<K = any, T = any> = (args: K) => ApiConfig<T>;

export const createApiMap = () => {
    const createApiConfig = <T = any>(url: string, method: API_METHOD, params?: T, data?: T): ApiConfig<T> => ({
        url,
        method,
        params,
        data
    });

    const searchData: APIFunctionType<SearchPayloadType, any> = (args) => {
        const baseApiUrl = sessionStorage.getItem('API_BASE_URL') || '';
        const ws_code = getWS_Code();
        const params = {
            ws_code,
            ...args
        };
        // Remove '/v1' from baseApiUrl if present
        return createApiConfig(`${baseApiUrl}${API_TEMPLATE.SEARCH_API}`, API_METHOD.GET, params);
    };

    const getUserInformation: APIFunctionType<undefined, undefined> = () => {
        const baseApiUrl = sessionStorage.getItem('API_BASE_URL') || '';
        return createApiConfig(`${baseApiUrl}${API_TEMPLATE.GET_USER_INFORMATION}`, API_METHOD.GET);
    };

    const getUserPermission: APIFunctionType<undefined, undefined> = () => {
        const baseApiUrl = sessionStorage.getItem('API_BASE_URL') || '';
        const ws_code = getWS_Code();
        const url = `${baseApiUrl}${API_TEMPLATE.GET_PERMISSION.replace('{ws_code}', ws_code)}`;
        return createApiConfig(url, API_METHOD.GET);
    };
    const getUserRootRole: APIFunctionType<string, undefined> = (id: string) => {
        const baseApiUrl = sessionStorage.getItem('API_BASE_URL') || '';
        const ws_code = getWS_Code();
        const apiUrl = baseApiUrl.replace('/v1', '');
        const url = `${apiUrl}${API_TEMPLATE.GET_ROOT_ROLES.replace('{ws_code}', ws_code)}`.replace('{id}', id);
        return createApiConfig(url, API_METHOD.GET);
    };
    const getUserConfig: APIFunctionType<undefined, undefined> = () => {
        const baseApiUrl = sessionStorage.getItem('API_BASE_URL') || '';
        const ws_code = getWS_Code();
        const url = `${baseApiUrl}${API_TEMPLATE.GET_USER_CONFIG.replace('{ws_code}', ws_code)}`;
        return createApiConfig(url, API_METHOD.GET);
    };
    const getWsInformation: APIFunctionType<undefined, undefined> = () => {
        const baseApiUrl = sessionStorage.getItem('API_BASE_URL') || '';
        const ws_code = getWS_Code();
        const url = `${baseApiUrl}${API_TEMPLATE.GET_WS_PAGES.replace('{ws_code}', ws_code)}`;
        return createApiConfig(url, API_METHOD.GET);
    };
    return {
        searchData,
        getUserInformation,
        getUserPermission,
        getUserRootRole,
        getUserConfig,
        getWsInformation
    };
};
